module.exports = __webpack_public_path__ + "static/media/login_bg_mb.b60f6ff3.png";